var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4381 8H21.5C22.6046 8 23.5 8.89543 23.5 10V14C23.5 15.1046 22.6046 16 21.5 16H20.4381C19.946 19.9463 16.5796 23 12.5 23V21C15.8137 21 18.5 18.3137 18.5 15V9C18.5 5.68629 15.8137 3 12.5 3C9.18629 3 6.5 5.68629 6.5 9V16H3.5C2.39543 16 1.5 15.1046 1.5 14V10C1.5 8.89543 2.39543 8 3.5 8H4.56189C5.05399 4.05369 8.42038 1 12.5 1C16.5796 1 19.946 4.05369 20.4381 8ZM3.5 10V14H4.5V10H3.5ZM20.5 10V14H21.5V10H20.5ZM8.25944 15.7849L9.31958 14.0887C10.2416 14.6662 11.3318 15 12.5 15C13.6682 15 14.7584 14.6662 15.6804 14.0887L16.7406 15.7849C15.5112 16.5549 14.0576 17 12.5 17C10.9424 17 9.48882 16.5549 8.25944 15.7849Z",
    fill: "#FFB829"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon_message.764d5b5a4dc841793a1f3f52a72882c7.svg";
export { ForwardRef as ReactComponent };